import { PageHeader } from "../../../components/AppLayout";
import { Card } from "../../../components/shared/Card";
import { EmptyState } from "../../../components/shared/EmptyState";

export function OwnerSkillsCatalog() {
  return (
    <>
      <PageHeader title="Skills catalog" subtitle="Public skills you can install." />
      <Card>
        <EmptyState title="Catalog in Phase 4" />
      </Card>
    </>
  );
}

export function OwnerMySkills() {
  return (
    <>
      <PageHeader title="My skills" subtitle="Skills your org has installed or owns privately." />
      <Card>
        <EmptyState title="My skills in Phase 4" />
      </Card>
    </>
  );
}
